export const contactsTableHeaders = ["Name", "Position", "Email", "Phone"];
export const contractsTableHeaders = ["No", "Name", "Start Date", "End Date", "Renawal Date", "Total Cost"];
export const dateFormat = "MMMM Do YYYY";
